import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ReportIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 16.712a.78.78 0 0 0 .575-.233.78.78 0 0 0 .233-.575.78.78 0 0 0-.232-.576.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.233.576q0 .343.232.575a.78.78 0 0 0 .576.233m-.75-3.481h1.5V7.192h-1.5zM8.461 20.5 3.5 15.543V8.461L8.457 3.5h7.082L20.5 8.457v7.082L15.543 20.5zM9.1 19h5.8l4.1-4.1V9.1L14.9 5H9.1L5 9.1v5.8z" />
    </Icon>
  );
}

ReportIcon.displayName = 'ReportIcon';
